import { Alert, Button, DialogActions, Grid, useTheme } from "@mui/material";
import { isEqual } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { EXPENSE_REPORT_STATUS } from "../../../../../utils/constants/constants";
import { ExpenseReportStatusType } from "../AddEditExpenseReport";

interface Props {
  isAllowedToApprove: boolean;
  isAllowedToApprovePayment: boolean;
  expenseReportStatusId: string | undefined;
  handleChangeStatus: (newStatus: ExpenseReportStatusType) => void;
  documentation: boolean;
  handleChangeDocStatus: (newDocStatus: boolean) => void;
  error: string;
}

const ManagerActions = ({
  isAllowedToApprove,
  isAllowedToApprovePayment,
  expenseReportStatusId,
  error,
  handleChangeStatus,
  documentation,
  handleChangeDocStatus,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "pages.manage_travel_and_expenses.tables.expense_reports.expense_report_details";

  const theme = useTheme();

  return (
    <DialogActions style={{ flexDirection: "column", gap: "15px", padding: "20px" }}>
      <Grid
        style={{
          display: "flex",
          gap: "15px",
          justifyContent: "center",
        }}
      >
        {isAllowedToApprove && isEqual(expenseReportStatusId, EXPENSE_REPORT_STATUS.submitted.id) && (
          <>
            <Button
              size="small"
              onClick={() => {
                handleChangeStatus(EXPENSE_REPORT_STATUS.returned_to_employee);
              }}
              variant={"contained"}
              style={{
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.actions.cancel,
              }}
            >
              {`${t(`${tRP}.buttons.send_back_to_employee`)}`}
            </Button>
            <Button
              size="small"
              onClick={() => {
                handleChangeStatus(EXPENSE_REPORT_STATUS.approved);
              }}
              variant={"contained"}
              color="primary"
            >
              {`${t(`${tRP}.buttons.approve`)}`}
            </Button>
            {!documentation && (
              <Button
                size="small"
                onClick={() => {
                  handleChangeDocStatus(true);
                }}
                variant={"contained"}
                color="info"
              >
                {`${t(`${tRP}.buttons.mark_documentation_audit_ok`)}`}
              </Button>
            )}

            <Button
              size="small"
              onClick={() => {
                handleChangeStatus(EXPENSE_REPORT_STATUS.rejected);
              }}
              variant={"contained"}
              color="error"
            >
              {`${t(`${tRP}.buttons.reject`)}`}
            </Button>
          </>
        )}

        {isAllowedToApprovePayment &&
          (isEqual(expenseReportStatusId, EXPENSE_REPORT_STATUS.submitted.id) ||
            isEqual(expenseReportStatusId, EXPENSE_REPORT_STATUS.approved.id)) && (
            <Button
              size="small"
              onClick={() => {
                handleChangeStatus(EXPENSE_REPORT_STATUS.paid);
              }}
              variant={"contained"}
              color="success"
            >
              {`${t(`${tRP}.buttons.mark_as_paid`)}`}
            </Button>
          )}
      </Grid>

      {error && <Alert severity="error">{error}</Alert>}
    </DialogActions>
  );
};

export default ManagerActions;
